import {AuditTrailUserModel} from "../../../__generated__/generated_types";

export function renderAuditLogUsername(user: AuditTrailUserModel | null | undefined): string {
    if(!user) {
        return "N/A";
    }

    return user.email.endsWith("@vizibly.io") ?
        "System" :
        `${user.firstName} ${user.lastName} (${user.email})`;
}